export const version = '0.802.0-SNAPSHOT'
export const chameleonWebVersion = '10.1.1'
export const chameleonCoreVersion = '7.12.1'
